
export const ACCESSPERMISSION = {
  OVERVIEW_EDIT: 'overview_edit',
  SCOPED_EDIT: 'scopeddeals_edit',
  DEALREVIEW_APPROVED: 'dealreview_approve_reject',
  DEALREVIEW_EDIT: 'dealreview_edit',
  INAB_NEW_SUBMISSION: 'inab_create_submissions_send_rm',
  INAB_APPROVED_SUBMISSION: 'inab_approve_reject_dealsubmissions',
  LEGAL_EDIT: 'legalreview_edit',
  LEGAL_APPROVED: 'legalreview_approve_reject',
  RM_PEOPLE_EDIT: 'rm_people_list_edit',
  RM_PEOPLE_VIEW: 'rm_people_list_view',
  RM_PROFILE_EDIT: 'rm_employee_profile_edit',
  MY_PROFILE_EDIT:'my_profile_edit',
  RM_PROFILE_VIEW: 'rm_employee_profile_view',
  RM_PROPJECT_EDIT: 'rm_project_edit',
  RM_DEMANDPIPELINE_EDIT: 'rm_demand_pipeline_edit',
  RM_RESOURCE_ALLOCATION_EDIT: 'rm_resource_allocation_edit',
  RM_RESOURCE_ALLOCATION_APPROVED: 'rm_resource_allocation_approve_reject',
  ADMIN_USER_MANAGEMENT_EDIT: 'admin_usermanagement_edit',
  ADMIN_USER_MANAGEMENT_DELETE: 'admin_usermanagement_delete',
  ADMIN_NOTIFICATION_EDIT: 'notification_edit',
  ADMIN_ACCESSPOLICY_EDIT: 'admin_accesspolicy_edit',
  ADMIN_ACCESSPOLICY_DELETE: 'admin_accesspolicy_delete',
  ADMIN_RATECARD_EDIT: 'admin_ratecard_edit',
  ADMIN_RATECAED_DELETE: 'admin_ratecard_delete',
  PLAYGROUND_EDIT: 'playground_edit',
  ADMIN_SKILLS_AND_CERTIFICATION_EDIT:'admin_skillscertification_edit',
  PLAYGROUND_VIEW_AND_EDIT : 'playground_view_edit',
  RM_REPORT_GENERATION_VIEW : 'report_generation_view',
  RM_REPORT_GENERATION_EDIT : 'report_generation_edit',
}

export const CollaboratorPath = {
//navigation route check
scoped: '/scoped',
dealreview: '/deal-review',
playground: '/playground',
projects: '/projects',
};

export const CollaboratorStatusPath = {
scoped: '/scoped',
dealreview: '/deal-review',
inab: '/inab',
legalreview:'/legal-dashboard',
rmclientprojects:'/projects/project-details',
rminabprojects:'/projects/inab-details',
demand:'/rm/demandpipeline/preliminary-staffing',
projectdemand:'/rm/demandpipeline/project-demand',
resourceallocation:'/rm/resource-allocation-dashboard'
}
